export default class Vector2 {
  private _x = 0;
  private _y = 0;

  public get x(): number {
    return this._x;
  }

  public get y(): number {
    return this._y;
  }

  public rotateAround(center: Vector2, angle: number) {
    angle = (3.14 / 180) * angle;
    var diff = this.sub(center);
    var rotatedDiff = new Vector2(
      diff.x * Math.cos(angle) - diff.y * Math.sin(angle),
      diff.x * Math.sin(angle) + diff.y * Math.cos(angle)
    );

    return rotatedDiff.add(center);
  }

  public toString(): string {
    return `Vector2(${this._x}, ${this._y})`;
  }

  public sub(other: Vector2): Vector2 {
    return new Vector2(this._x - other._x, this._y - other._y);
  }

  public add(other: Vector2): Vector2 {
    return new Vector2(this._x + other._x, this._y + other._y);
  }

  public mul(other: Vector2): Vector2 {
    return new Vector2(this._x * other._x, this._y * other._y);
  }

  public div(other: Vector2): Vector2 {
    return new Vector2(this._x / other._x, this._y / other._y);
  }

  public mulScalar(scalar: number): Vector2 {
    return new Vector2(this._x * scalar, this._y * scalar);
  }

  public divScalar(scalar: number): Vector2 {
    return new Vector2(this._x / scalar, this._y / scalar);
  }

  public magnitude(): number {
    return Math.sqrt(this._x * this._x + this._y * this._y);
  }

  public distanceTo(other: Vector2): number {
    var sub = this.sub(other);
    return sub.magnitude();
  }

  public get isZero(): boolean {
    return this._x < 0.001 && this._y < 0.001;
  }

  public limitToMin(min: Vector2): Vector2 {
    return new Vector2(Math.max(min.x, this.x), Math.max(min.y, this.y));
  }

  public constructor(x = 0, y = 0) {
    this._x = x;
    this._y = y;
  }
}
